import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDresser: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconDresser"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3V10H21V3H3ZM14 5H10V7H14V5Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M3 19V12H21V19H18V22H16V19H8V22H6V19H3ZM10 16V14H14V16H10Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDresser;
